export default __webpack_public_path__ + "static/media/treasure_box.efacf7d0.png";